import React from "react";
import { UseFormReturn } from "react-hook-form";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { AgeGroupVariationFormData } from "../schemas/ageGroupVariationSchema";
import { LegacyInformationUrlReadOnly } from "@/components/admin/locations/components/ProgramLinkReadOnly";

interface ProgramLinkFieldsProps {
  form: UseFormReturn<AgeGroupVariationFormData>;
  /** The program's stored legacy `url` ("Information URL"), shown read-only when present. */
  legacyUrl: string | null | undefined;
}

type LinkFieldName = "programUrl" | "defaultSessionUrl" | "regUrl";

const LINK_FIELDS: Array<{ name: LinkFieldName; label: string; placeholder: string; hint: string }> = [
  {
    name: "programUrl",
    label: "Program website",
    placeholder: "https://example.com/programs/summer-camp",
    hint: "The page that describes this program. Copied to every session.",
  },
  {
    name: "defaultSessionUrl",
    label: "Default session website (optional)",
    placeholder: "https://example.com/programs/summer-camp/week-1",
    hint: "Pre-fills each new session's Session website. Leave blank if sessions have no page of their own.",
  },
  {
    name: "regUrl",
    label: "Registration (default, optional)",
    placeholder: "https://example.com/register",
    hint: "Pre-fills each new session's Registration link.",
  },
];

/** KB-4351 — the program's three links, plus its legacy Information URL (read-only). */
export const ProgramLinkFields: React.FC<ProgramLinkFieldsProps> = ({ form, legacyUrl }) => (
  <>
    {LINK_FIELDS.map(({ name, label, placeholder, hint }) => (
      <FormField
        key={name}
        control={form.control}
        name={name}
        render={({ field }) => (
          <FormItem>
            <FormLabel>{label}</FormLabel>
            <FormControl>
              <Input type="url" placeholder={placeholder} {...field} value={field.value ?? ""} />
            </FormControl>
            <p className="text-sm text-muted-foreground">{hint}</p>
            <FormMessage />
          </FormItem>
        )}
      />
    ))}
    <LegacyInformationUrlReadOnly url={legacyUrl} />
  </>
);
